module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2YjQ2NTUzOWQzOTYzY2FhYWRhZmE3NDMzZDFjZjhmNy5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icons/iconfont.svg
// module id = 221
// module chunks = 0